import React, { useEffect, useState } from 'react'
import { Typography, withStyles, Tooltip } from '@material-ui/core'
import styles from './styles'
import { CoreButton } from 'src/components/core'
import { Icon } from '@iconify/react'
import { useHistory } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { domainListAction } from 'src/reducers/domain/action'
import URL from 'src/api/url'
import { patchCourseLandingPageAction } from 'src/reducers/course/action'
import { patchCollectionLandingPageAction } from 'src/reducers/collection/action'
import { templateDataCollection, templateDataCourse } from '../../data'

const HeaderLandingPage = props => {
  const { classes, course, pageUrl, selectedTemplateId } = props
  const dispatch = useDispatch()
  const [copied, setCopied] = useState(false)
  const history = useHistory()
  const { id, page } = useParams()
  const collection = useSelector(state => state.collection.collection)
  const [domainName, setDomainName] = useState('share.minicoursegenerator.com')
  const [domains, setDomains] = useState([])
  const [loading, setLoading] = useState(true)

  const customDomain = useSelector(state => state.domain.list)
  const customDomainList = customDomain && customDomain.results

  // Get landing page settings
  const courseSettings = useSelector(state => state.course.landingPageSettings)
  const collectionSettings = useSelector(
    state => state.collection.landingPageSettings,
  )
  const landingPageData =
    pageUrl === 'mini-course' ? courseSettings : collectionSettings

  useEffect(() => {
    const queryDomainList = {
      CurrentPage: 0,
      PageSize: 200,
      SortingColumn: 'LastModifiedAt',
      Asc: false,
      FilterText: '',
      Filters: [],
    }

    if (customDomain.results != null) {
      setLoading(false)
      return
    }
    dispatch(domainListAction(queryDomainList, () => setLoading(false)))
  }, [])

  useEffect(() => {
    if (customDomainList) {
      if (pageUrl === 'collection') {
        const collectionDomain = customDomainList.filter(
          item =>
            item.defaultCollectionDto != null &&
            item.defaultCollectionDto.id == id &&
            item.verificationStatus == 1,
        )
        setDomains(collectionDomain)

        if (collectionDomain.length > 0) {
          setDomainName(collectionDomain[0].domain)
        }
      } else {
        const courseDomain = customDomainList.filter(
          item =>
            item.defaultCourseDto != null &&
            item.defaultCourseDto.id == id &&
            item.verificationStatus == 1,
        )
        setDomains(courseDomain)

        if (courseDomain.length > 0) {
          setDomainName(courseDomain[0].domain)
        }
      }
    }
  }, [customDomainList, id, course?.id, pageUrl])

  const getFullUrl = () => {
    if (domainName != 'share.minicoursegenerator.com') {
      return `https://${domainName}`
    }
    const baseUrl = domainName || URL.APP_URL

    if (pageUrl === 'collection') {
      if (!collection) return null

      const formattedName = collection.name
        .replaceAll(' ', '-')
        .replaceAll('?', '')
        .replaceAll('&', '')

      return `https://${baseUrl}/category/${formattedName}-1/${collection.id}`
    } else {
      // For mini-course
      if (!course || !course.code) return null
      return `https://${baseUrl}/${course.code}`
    }
  }
  const url = getFullUrl()

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url)
      setCopied(true)
      setTimeout(() => {
        setCopied(false)
      }, 2000)
    } catch (err) {
      console.error('Copy failed:', err)
    }
  }

  // Function to navigate to the desired page after saving
  const navigateAfterSave = () => {
    if (pageUrl === 'mini-course') {
      history.push('/mini-course/' + course.id + '/landing-page/editor')
    } else {
      history.push('/collection/' + id + '/landing-page/editor')
    }
  }

  // Function to apply the selected template
  const applySelectedTemplate = () => {
    // If no template is selected or already initialized, skip this step
    if (
      !selectedTemplateId ||
      selectedTemplateId === 0 ||
      landingPageData?.initialized === true
    ) {
      return false // Return false to indicate no save was needed
    }

    const activeTemplateData =
      pageUrl === 'mini-course' ? templateDataCourse : templateDataCollection
    const selectedTemplateObject = activeTemplateData.find(
      template => template.id === selectedTemplateId,
    )

    if (!selectedTemplateObject) return false // Return false to indicate no save was needed

    const patchAction =
      pageUrl === 'mini-course'
        ? patchCourseLandingPageAction
        : patchCollectionLandingPageAction

    // Dispatch the save action - keep the original structure
    dispatch(
      patchAction(id, [
        {
          path: 'initialized',
          value: true,
        },
        {
          path: 'primaryColor',
          value: selectedTemplateObject.primaryColor,
        },
        {
          path: 'font',
          value: selectedTemplateObject.font,
        },
        {
          path: 'sections',
          value: selectedTemplateObject.value,
        },
      ]),
    )

    return true
  }

  const handleClick = () => {
    const saveTriggered = applySelectedTemplate()

    if (saveTriggered) {
      setTimeout(() => {
        navigateAfterSave()
      }, 1000)
    } else {
      navigateAfterSave()
    }
  }

  return (
    <div className={classes.content}>
      <div className={classes.header}>
        <div>
          <Typography className={classes.headerText}>
            Landing page preview
          </Typography>
        </div>

        <div className={classes.urlContent}>
          <div className={classes.textContainer}>
            <div className={classes.urlWithIcon}>
              <Tooltip
                title={
                  <span>
                    You can customize the default URL by linking it to your own
                    domain on the "
                    <Link to="/custom-domain" className={classes.link}>
                      Custom Domain
                    </Link>
                    " page.
                  </span>
                }
                placement="bottom"
                arrow
              >
                <div className={classes.questionIcon}>
                  <Icon
                    icon="solar:question-circle-outline"
                    color="#838D98"
                    width="16"
                    height="16"
                  />
                </div>
              </Tooltip>
              <Typography className={classes.urlText}>{url && url}</Typography>
            </div>
          </div>
          <div className={classes.copy}>
            <Typography className={classes.copyText} onClick={handleCopy}>
              {copied ? 'Copied!' : 'Copy'}
            </Typography>
          </div>
        </div>

        <div>
          <CoreButton
            onClick={() => handleClick()}
            size="medium"
            color="secondary"
            variant="contained"
          >
            Edit landing page
          </CoreButton>
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(HeaderLandingPage)
